export function getAboveFoldStories(limit, offset, topStoryIds) {
  return global.wretch('/api/v1/collections/above-the-fold').query({
    limit,
    offset,
    'exclude-story-ids': topStoryIds ? topStoryIds.toString() : '',
    'item-type': 'story',
  });
}
